import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

import { DeliAreaService } from '../../../service/deli-area/deli-area.service';
import { DeliRouteService } from '../../../service/deli-route/deli-route.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9175.component.html',
  styleUrls: ['wa9175.component.css']
})
export class Wa9175Component implements OnInit {
  public componentTitle = 'WA9175:配送ルートマスタ修正';

  public deliareas: any;
  public alldeliareas: any;

  public deliareadisplayTx: FormControl;

  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public delirouteId: number;
  public delirouteCd: string;
  public delirouteTx: FormControl;
  public deliareaId: number;

  public filteredDeliareaOptions: Observable<string[]>;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(
    private router: Router,
    private deliAreaService: DeliAreaService,
    private deliRouteService: DeliRouteService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    const deliroute: object = JSON.parse(sessionStorage.getItem('deliroute'));
    this.ownerId = deliroute['ownerId'];
    this.ownerCd = deliroute['ownerCd'];
    this.ownerTx = deliroute['ownerTx'];
    this.delirouteId = deliroute['delirouteId'];
    this.delirouteCd = deliroute['delirouteCd'];
    var delirouteTx = deliroute['delirouteTx'];
    var deliareadisplayTx = deliroute['deliareadisplayTx'];
    this.deliareaId = deliroute['deliareaId'];
    this.deliareadisplayTx = new FormControl(deliareadisplayTx, Validators.required);
    (this.delirouteTx = new FormControl(delirouteTx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.delirouteTx.maxLength)
    ])),
      (this.working = true);
    this.deliAreaService
      .get(1)
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.alldeliareas = outputJson.deliareas;
        this.deliareas = this.getDeliareaOwners();
        this.filteredDeliareaOptions = this.deliareadisplayTx.valueChanges.startWith(null).map(val => (val ? this.deliareaFilter(val) : this.deliareas));
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.working = false;
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit() {}

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onSubmit() {
    var delirouteTx = this.delirouteTx.value.trim();
    let errors = false;
    if (this.deliareadisplayTx.errors !== null) {
      this.deliareadisplayTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.working = true;
    this.deliRouteService
      .put(this.ownerId, this.delirouteId, this.delirouteCd, delirouteTx, this.deliareaId, 'wa9175')
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa9173']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  deliareaFilter(val: string): string[] {
    this.deliareas = this.getDeliareaOwners();
    if (this.deliareas !== undefined) {
      return this.deliareas.filter(deliarea => deliarea.deliareadisplayTx.indexOf(val) !== -1);
    }
  }

  getDeliareaOwners(): any[] {
    if (this.ownerId !== undefined && this.alldeliareas !== undefined) {
      var deliareaOwners = this.alldeliareas.filter((item, index) => {
        if (item.ownerId === this.ownerId) return true;
      });
    }
    return deliareaOwners;
  }

  changeDeliarea(event: number) {
    this.deliareaId = this.getDeliareaId();
  }

  getDeliareaId() {
    this.deliareas = this.getDeliareaOwners();
    if (this.deliareas !== undefined && this.deliareadisplayTx.value.trim() !== '') {
      var selectedDeliareas = this.deliareas.filter((item, index) => {
        if (item.deliareadisplayTx === this.deliareadisplayTx.value.trim()) return true;
      });
      if (selectedDeliareas.length > 0) {
        return selectedDeliareas[0]['deliareaId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9175/wa9175.component.ts